export default {
	apiRoot: process.env.REACT_APP_API_ROOT,
	vefurRoot: process.env.REACT_APP_API_ROOT+'/vefur',
	//vefurRoot: 'http://130.208.108.18:8000/vefur',
	neo4jApi: 'https://ordanet.arnastofnun.is/graph',

	pageSize: 50,
	gaTrackingId: 'G-Y8NESXH2RT'
}
